import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import PromotionBanner from '../PromotionBanner/PromotionBanner';

export default function SiteLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'black',
      }}
    >
      <Header />
      {/* <PromotionBanner /> */}
      <Box
        component="main"
        sx={{
          flex: 1,
          pt: '60px',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
}